module.exports = __webpack_public_path__ + "img/53_45.ae796213.png";